var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8367 24.8365 32 16 32C7.16345 32 0 24.8367 0 16C0 7.16333 7.16345 0 16 0C24.8365 0 32 7.16333 32 16ZM23 12L19 16H22C22 17.5913 21.3679 19.1174 20.2426 20.2427C19.1174 21.3679 17.5913 22 16 22C15 22 14.03 21.75 13.2 21.3L11.74 22.76C12.97 23.54 14.4301 24 16 24C18.1217 24 20.1566 23.1572 21.6569 21.657C23.1571 20.1565 24 18.1216 24 16H27L23 12ZM10 16C10 14.4087 10.6321 12.8826 11.7574 11.7573C12.8826 10.6321 14.4087 10 16 10C17 10 17.97 10.25 18.8 10.7L20.26 9.23999C19.03 8.45996 17.5699 8 16 8C13.8783 8 11.8434 8.84277 10.3431 10.343C8.8429 11.8435 8 13.8784 8 16H5L9 20L13 16H10ZM21.59 9L23 10.4099L17.41 16L16 17.4099L10.41 23L9 21.5901L14.59 16L16 14.5901L21.59 9Z",
    fill: "#A1AAB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBonus);
export default __webpack_public_path__ + "static/media/cancel-bonus.775e6ef5.svg";
export { ForwardRef as ReactComponent };